import { createContext, useContext } from "react";
import type { Artifact } from "@lumen/shared";
import type { ComposerSkill } from "../composer/Composer";
import type { DevelopmentSelection } from "./ChatDevelopmentPanel.types";
export type Mention = { reference: string; selection: DevelopmentSelection };
export const ChatMentionsContext = createContext<{
  skills: ComposerSkill[];
  artifacts: Artifact[];
  selected?: Mention;
  open: (mention: Mention) => void;
} | null>(null);
export const useChatMentions = () => useContext(ChatMentionsContext);
